import React from "react"

const HeroText = ( { textQuote } ) => (
    <div className="container-fluid hero-container">
        <div className="row align-items-center h-100">
            <div className="col">
                <p className="display-4 hero-text">
                    {textQuote}
                </p>
            </div>
        </div>
    </div>
)

export default HeroText